"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAvailableTemplateOrientations = void 0;
const templates_1 = require("../types/templates");
/**
 * Return available orientations given Template supports.
 * Template does not support orientation if it's style property is empty.
 * @param template
 */
const selectAvailableTemplateOrientations = (template) => {
    if (Object.keys(template.components.portrait).length === 0) {
        return [templates_1.TemplateOrientation.landscape];
    }
    else if (Object.keys(template.components.landscape).length === 0) {
        return [templates_1.TemplateOrientation.portrait];
    }
    else {
        return [templates_1.TemplateOrientation.landscape, templates_1.TemplateOrientation.portrait];
    }
};
exports.selectAvailableTemplateOrientations = selectAvailableTemplateOrientations;
//# sourceMappingURL=templates.js.map